import api from "../config/api";
import { TaskLog } from "../types/TaskLog";

const API_URL = "/taskLog";

export const getTaskLogs = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

export const getTaskLogById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const createTaskLog = (data: TaskLog) => api.post(`${API_URL}/`, data);

export const updateTaskLog = (id: number, data: TaskLog) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteTaskLog = (id: number) => api.delete(`${API_URL}/?id=${id}`);
